<template>
  <v-container fill-height>
    <v-layout justify-center>
      <v-flex>
        <span class="breadcrumbs__title">Crear / Editar</span>
        <v-icon>mdi-chevron-right</v-icon>
        <span>Factura Emitidas</span>
        <v-divider class="mt-2"></v-divider>
        <Snackbar :textError="textError" :isSnackbar="isSnackbar" />
        <v-row class="mt-10">
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title class="text-h6">Información Básica</v-card-title>
              <div class="separator"></div>
              <v-divider v-if="getDgUser"></v-divider>
              <v-col v-if="getDgUser" cols="12">
                <p>
                  Al activar la casilla la factura pasará a ser privada solo
                  accesible para el Director General, el promotor y validador.
                </p>
                <v-checkbox
                  v-model="invoice.privado"
                  id="private"
                  label="Factura privada"
                  color="primary"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-divider></v-divider>
              <v-card-text class="text--primary pt-6">
                <v-form ref="form" v-model="valid" lazy-validation width="100%">
                  <v-row>
                    <v-col cols="3">
                      <v-autocomplete
                        :disabled="newDisable"
                        v-model="invoice.company"
                        :items="contractingCompanies"
                        outlined
                        label="Emisora"
                        item-text="name"
                        item-value="name"
                        :rules="dropDownField"
                        required
                      ></v-autocomplete
                    ></v-col>

                    <v-col cols="4">
                      <v-row no-gutters>
                        <v-col cols="10">
                          <v-file-input
                            :disabled="newDisable"
                            v-model="invoiceFile"
                            label="Archivo Factura PDF"
                            :rules="emptyField"
                            required
                          ></v-file-input>
                        </v-col>
                        <v-col cols="2" class="mt-3">
                          <v-icon
                            large
                            v-if="invoice.PDFinvoiceFile"
                            @click="
                              downloadFile(
                                invoice.PDFinvoiceFile,
                                invoice.PDFinvoiceFileName
                              )
                            "
                          >
                            mdi-file-download-outline
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="4">
                      <v-row no-gutters>
                        <v-col cols="10">
                          <v-file-input
                            v-model="emailFile"
                            label="Registro de envío"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="2" class="mt-3">
                          <v-icon
                            large
                            v-if="invoice.emailFile"
                            @click="
                              downloadFile(
                                invoice.emailFile,
                                invoice.emailFileName
                              )
                            "
                          >
                            mdi-file-download-outline
                          </v-icon>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row class="dense_layout">
                    <v-col cols="3">
                      <v-text-field
                        :disabled="newDisable"
                        v-model="invoice.invoiceNumber"
                        label="Numero Factura"
                        outlined
                        :rules="emptyField"
                        required
                      ></v-text-field
                    ></v-col>
                    <v-col cols="3"
                      ><v-menu
                        :disabled="newDisable"
                        v-model="ff"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :disabled="newDisable"
                            v-model="invoice.invoiceDate"
                            label="Fecha Factura"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                            :rules="emptyField"
                            required
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="invoice.invoiceDate"
                          @input="ff = false"
                          locale="es-ES"
                          :first-day-of-week="1"
                        ></v-date-picker> </v-menu
                    ></v-col>
                    <v-col cols="3"
                      ><v-autocomplete
                        :disabled="newDisable"
                        v-model="invoice.client"
                        :items="getClients"
                        outlined
                        label="Cliente"
                        item-text="businessName"
                        item-value="id"
                        :rules="dropDownField"
                        required
                      ></v-autocomplete
                    ></v-col>
                    <v-col cols="3"
                      ><v-autocomplete
                        :disabled="newDisable"
                        v-model="invoice.invoiceManager.costCenter"
                        :items="centros"
                        outlined
                        label="Centro de coste"
                        item-text="name"
                        item-value="name"
                        :rules="dropDownField"
                        required
                      ></v-autocomplete
                    ></v-col>
                  </v-row>
                  <v-row> </v-row>
                  <v-row class="dense_layout mt-2">
                    <v-col cols="3">
                      <CurrencyInput
                        :disabled="newDisable"
                        label="Base imponible"
                        outlined
                        v-model="invoice.taxBase"
                        @formatWithCurrency="formatWithCurrency('taxBase')"
                    /></v-col>
                    <v-col cols="3">
                      <CurrencyInput
                        :disabled="newDisable"
                        label="Total IVA"
                        outlined
                        v-model="invoice.totalVAT"
                        @formatWithCurrency="formatWithCurrency('totalVAT')"
                    /></v-col>
                    <v-col cols="3">
                      <CurrencyInput
                        :disabled="newDisable"
                        label="Total Retencion"
                        outlined
                        v-model="invoice.totalWithholding"
                        @formatWithCurrency="
                          formatWithCurrency('totalWithholding')
                        "
                    /></v-col>
                    <v-col cols="3">
                      <CurrencyInput
                        :disabled="newDisable"
                        label="Total a Cobrar"
                        outlined
                        v-model="invoice.totalTopay"
                        :readonly="true"
                      />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3">
                      <v-card-title class="text-h6 pl-0"
                        >Gestor Factura
                      </v-card-title>
                      <v-autocomplete
                        :disabled="newDisable"
                        v-model="invoice.invoiceManager.managingPerson"
                        :items="getAllUsers"
                        outlined
                        label="Persona Gestora"
                        item-text="name"
                        item-value="id"
                        :rules="dropDownField"
                        required
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="3"> </v-col>
                    <v-col cols="3">
                      <v-card-title class="text-h6 pl-0"
                        >Validador Factura
                      </v-card-title>
                      <v-autocomplete
                        :disabled="newDisable"
                        v-model="invoice.invoiceManager.validatingPerson"
                        :items="getUsersWithFullName"
                        outlined
                        label="Persona Validadora"
                        item-text="name"
                        item-value="id"
                        :rules="dropDownField"
                        required
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row class="super-class mt-0">
                    <v-col
                      v-if="
                        invoice.managingPersonDetails.date ||
                        invoice.validatingPerson.date
                      "
                      :cols="
                        invoice.managingPersonDetails.date &&
                        invoice.validatingPerson.date
                          ? 12
                          : 6
                      "
                    >
                      <v-row>
                        <v-col
                          v-if="invoice.managingPersonDetails.date"
                          :cols="invoice.validatingPerson.date ? 6 : 12"
                        >
                          <v-row no-gutters>
                            <v-col cols="12">
                              <!-- This shows when validation from gestor is already done -->
                              <v-card-title
                                class="
                                  text-h6
                                  custom__title
                                  primary--text
                                  py-0
                                  pl-0
                                "
                                >Validación Gestor
                              </v-card-title>
                            </v-col>
                            <v-col cols="3">
                              <v-radio-group
                                disabled
                                v-model="
                                  invoice.managingPersonDetails.validation
                                "
                                class="mt-0"
                              >
                                <v-radio :value="true">
                                  <template v-slot:label>
                                    <div>Aprobada</div>
                                  </template>
                                </v-radio>
                                <v-radio :value="false">
                                  <template v-slot:label>
                                    <div>No Aprobada</div>
                                  </template>
                                </v-radio>
                              </v-radio-group>
                            </v-col>
                            <v-col
                              cols="9"
                              v-if="
                                invoice.managingPersonDetails.date &&
                                !invoice.managingPersonDetails.validation
                              "
                            >
                              <v-textarea
                                rows="3"
                                v-model="
                                  invoice.managingPersonDetails.description
                                "
                                outlined
                                name="input-7-4"
                                label="Motivo Disconformidad"
                                readonly
                                disabled
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-col>
                        <!-- Disabled radio buttons info and motivo Validador -->
                        <v-col
                          v-if="invoice.validatingPerson.date"
                          :cols="!invoice.managingPersonDetails.date ? 12 : 6"
                        >
                          <v-row no-gutters>
                            <v-col cols="12">
                              <v-card-title
                                class="
                                  text-h6
                                  custom__title
                                  primary--text
                                  py-0
                                  pl-0
                                "
                                >Validación Validador
                              </v-card-title>
                            </v-col>
                            <v-col cols="3">
                              <v-radio-group
                                disabled
                                v-model="invoice.validatingPerson.validation"
                                class="mt-0"
                              >
                                <v-radio :value="true">
                                  <template v-slot:label>
                                    <div>Aprobada</div>
                                  </template>
                                </v-radio>
                                <v-radio :value="false">
                                  <template v-slot:label>
                                    <div>No Aprobada</div>
                                  </template>
                                </v-radio>
                              </v-radio-group>
                            </v-col>

                            <v-col
                              cols="9"
                              v-if="
                                invoice.validatingPerson.date &&
                                !invoice.validatingPerson.validation
                              "
                            >
                              <v-textarea
                                rows="3"
                                v-model="invoice.validatingPerson.description"
                                outlined
                                name="input-7-4"
                                label="Motivo Disconformidad"
                                disabled
                                readonly
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <div v-if="getFinalPersona() === 0">
                        <!-- Valida Gestor -->

                        <v-row
                          v-if="
                            invoiceManager &&
                            !invoice.managingPersonDetails.date
                          "
                          no-gutters
                        >
                          <v-col cols="12">
                            <!-- This shows when Gestor is != from promotor case AB-->
                            <v-card-title
                              class="
                                text-h6
                                custom__title
                                primary--text
                                py-0
                                pl-0
                              "
                              >Validación Gestor
                            </v-card-title>
                          </v-col>
                          <v-col cols="3">
                            <v-radio-group
                              :disabled="!invoiceManager"
                              v-model="invoice.managingPersonDetails.validation"
                              class="mt-0"
                            >
                              <v-radio :value="true">
                                <template v-slot:label>
                                  <div>Aprobada</div>
                                </template>
                              </v-radio>
                              <v-radio :value="false">
                                <template v-slot:label>
                                  <div>No Aprobada</div>
                                </template>
                              </v-radio>
                            </v-radio-group>
                          </v-col>
                          <!-- <v-col cols="7" class="d-flex align-center">
                          <span v-if="invoice.managingPersonDetails.date"
                            >Fecha aprovación/denegación:
                            {{ invoice.managingPersonDetails.date }}</span
                          >
                        </v-col> -->
                          <v-col
                            cols="9"
                            v-if="
                              invoiceManager &&
                              !invoice.managingPersonDetails.validation &&
                              !invoice.managingPersonDetails.date
                            "
                          >
                            <v-textarea
                              rows="3"
                              v-model="
                                invoice.managingPersonDetails.description
                              "
                              outlined
                              name="input-7-4"
                              label="Motivo Disconformidad"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                        <v-row
                          v-if="
                            invoiceManager &&
                            !invoice.managingPersonDetails.date
                          "
                        >
                          <v-col cols="6">
                            <v-checkbox
                              v-model="askForValidationManager"
                              id="dos"
                              label="Solicitar validación"
                              color="primary"
                              hide-details
                            ></v-checkbox>
                            <v-btn
                              class="mb-5 white--text px-8 mt-1"
                              :disabled="!valid"
                              color="primary"
                              @click="submit(1)"
                              ><v-icon left> mdi-content-save-outline</v-icon
                              >GUARDAR</v-btn
                            >
                          </v-col>
                        </v-row>

                        <!-- Valida Validador -->
                        <div
                          v-if="
                            invoice.managingPersonDetails.validation &&
                            invoice.managingPersonDetails.date &&
                            !invoice.validatingPerson.date
                          "
                        >
                          <v-row
                            no-gutters
                            v-if="isValidador || invoice.validatingPerson.date"
                          >
                            <v-col cols="12">
                              <v-card-title
                                class="
                                  text-h6
                                  custom__title
                                  primary--text
                                  py-0
                                  pl-0
                                "
                                >Validación Validador
                              </v-card-title>
                            </v-col>
                            <v-col cols="3">
                              <v-radio-group
                                :disabled="!isValidador"
                                v-model="invoice.validatingPerson.validation"
                                class="mt-0"
                              >
                                <v-radio :value="true">
                                  <template v-slot:label>
                                    <div>Aprobada</div>
                                  </template>
                                </v-radio>
                                <v-radio :value="false">
                                  <template v-slot:label>
                                    <div>No Aprobada</div>
                                  </template>
                                </v-radio>
                              </v-radio-group>
                            </v-col>
                            <!-- <v-col cols="7" class="d-flex align-center">
                            <span v-if="invoice.validatingPerson.date"
                              >Fecha aprovación/denegación:
                              {{ invoice.validatingPerson.date }}</span
                            >
                          </v-col> -->
                            <v-col
                              v-if="
                                (isValidador &&
                                  !invoice.validatingPerson.validation) ||
                                (invoice.validatingPerson.date &&
                                  !invoice.validatingPerson.validation)
                              "
                              cols="9"
                            >
                              <v-textarea
                                rows="3"
                                v-model="invoice.validatingPerson.description"
                                outlined
                                name="input-7-4"
                                label="Motivo Disconformidad"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                          <v-btn
                            v-if="isValidador"
                            class="mb-5 white--text px-8 mt-1"
                            :disabled="!valid"
                            color="primary"
                            @click="submit(2)"
                            ><v-icon left> mdi-content-save-outline</v-icon
                            >Guardar</v-btn
                          >
                        </div>
                      </div>
                      <div v-else-if="getFinalPersona() === 1">
                        <!-- If Promotor show save button + checkbox when gestor has validated -->

                        <div
                          v-if="
                            invoiceManager &&
                            !invoice.managingPersonDetails.date
                          "
                        >
                          <!-- Valida Gestor -->

                          <v-row no-gutters>
                            <!-- This shows when Gestor has to validate AA case  -->
                            <v-col cols="12">
                              <v-card-title
                                class="
                                  text-h6
                                  custom__title
                                  primary--text
                                  py-0
                                  pl-0
                                "
                                >Validación Gestor
                              </v-card-title>
                            </v-col>
                            <v-col cols="3">
                              <v-radio-group
                                :disabled="!invoiceManager"
                                v-model="
                                  invoice.managingPersonDetails.validation
                                "
                                class="mt-0"
                              >
                                <v-radio :value="true">
                                  <template v-slot:label>
                                    <div>Aprobada</div>
                                  </template>
                                </v-radio>
                                <v-radio :value="false">
                                  <template v-slot:label>
                                    <div>No Aprobada</div>
                                  </template>
                                </v-radio>
                              </v-radio-group>
                            </v-col>
                            <!-- <v-col cols="7" class="d-flex align-center">
                            <span v-if="invoice.managingPersonDetails.date"
                                >Fecha aprovación/denegación:
                                {{ invoice.managingPersonDetails.date }}</span
                              >
                            </v-col> -->

                            <v-col
                              v-if="
                                (invoiceManager &&
                                  !invoice.managingPersonDetails.validation) ||
                                (invoice.managingPersonDetails.date &&
                                  !invoice.managingPersonDetails.validation)
                              "
                              cols="9"
                            >
                              <v-textarea
                                rows="3"
                                v-model="
                                  invoice.managingPersonDetails.description
                                "
                                outlined
                                name="input-7-4"
                                label="Motivo Disconformidad"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="6">
                              <v-checkbox
                                v-model="askForValidationManager"
                                style="margin-top: 8px"
                                id="cuatro"
                                label="Solicitar validación"
                                color="primary"
                                hide-details
                              ></v-checkbox>
                              <v-btn
                                v-if="invoiceManager"
                                class="mb-5 white--text px-8 mt-1"
                                :disabled="!valid"
                                color="primary"
                                @click="submit(1)"
                                ><v-icon left> mdi-content-save-outline</v-icon
                                >Guardar</v-btn
                              >
                            </v-col>
                          </v-row>
                        </div>
                      </div>

                      <div v-else-if="getFinalPersona() === 2">
                        <!-- Valida Validador -->
                        <div v-if="!invoice.validatingPerson.date">
                          <v-row
                            no-gutters
                            v-if="isValidador || invoice.validatingPerson.date"
                          >
                            <v-col cols="12">
                              <v-card-title
                                class="
                                  text-h6
                                  custom__title
                                  primary--text
                                  py-0
                                  pl-0
                                "
                                >Validación Validador
                              </v-card-title>
                            </v-col>
                            <v-col cols="3">
                              <v-radio-group
                                :disabled="!isValidador"
                                v-model="invoice.validatingPerson.validation"
                                class="mt-0"
                              >
                                <v-radio :value="true">
                                  <template v-slot:label>
                                    <div>Aprobada</div>
                                  </template>
                                </v-radio>
                                <v-radio :value="false">
                                  <template v-slot:label>
                                    <div>No Aprobada</div>
                                  </template>
                                </v-radio>
                              </v-radio-group>
                            </v-col>
                            <!-- <v-col cols="7" class="d-flex align-center">
                            <span v-if="invoice.validatingPerson.date"
                              >Fecha aprovación/denegación:
                              {{ invoice.validatingPerson.date }}</span
                            >
                            </v-col> -->
                            <v-col
                              v-if="
                                (isValidador &&
                                  !invoice.validatingPerson.validation) ||
                                (invoice.validatingPerson.date &&
                                  !invoice.validatingPerson.validation)
                              "
                              cols="9"
                            >
                              <v-textarea
                                rows="3"
                                v-model="invoice.validatingPerson.description"
                                outlined
                                name="input-7-4"
                                label="Motivo Disconformidad"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                          <v-btn
                            v-if="isValidador"
                            class="mb-5 white--text px-8 mt-1"
                            :disabled="!valid"
                            color="primary"
                            @click="submit(2)"
                            ><v-icon left> mdi-content-save-outline</v-icon
                            >Guardar</v-btn
                          >
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <!-- {{ getFinalPersona() }} -->
                  <!-- Disabled radio buttons info and motivo GESTOR -->
                  <v-card-title class="text-h6 pl-0"
                    >Contabilidad
                  </v-card-title>
                  <v-row class="dense_layout">
                    <v-col cols="2">
                      <v-text-field
                        :disabled="!disableNotPtomoterContabilidad"
                        label="Debe"
                        outlined
                        v-model="invoice.cuentasContables.hasToPay"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-text-field
                        :disabled="!disableNotPtomoterContabilidad"
                        label="Haber"
                        outlined
                        v-model="invoice.cuentasContables.hasTohave"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2"
                      ><v-menu
                        :disabled="!disableNotPtomoterContabilidad"
                        v-model="fc"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :disabled="!disableNotPtomoterContabilidad"
                            v-model="invoice.postingDate"
                            label="Fecha contabilización"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="invoice.postingDate"
                          @input="fc = false"
                          locale="es-ES"
                          :first-day-of-week="1"
                        ></v-date-picker> </v-menu
                    ></v-col>
                    <v-col cols="2"
                      ><v-menu
                        :disabled="!disableNotPtomoterContabilidad"
                        v-model="fv"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :disabled="!disableNotPtomoterContabilidad"
                            v-model="invoice.expirationDate"
                            label="Fecha vencimiento"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="invoice.expirationDate"
                          @input="fv = false"
                          locale="es-ES"
                          :first-day-of-week="1"
                        ></v-date-picker> </v-menu
                    ></v-col>
                    <v-col cols="2"
                      ><v-menu
                        :disabled="!disableNotPtomoterContabilidad"
                        v-model="fp"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :disabled="!disableNotPtomoterContabilidad"
                            v-model="invoice.paymentDate"
                            label="Fecha de cobro"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            outlined
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="invoice.paymentDate"
                          @input="fp = false"
                          locale="es-ES"
                          :first-day-of-week="1"
                        ></v-date-picker> </v-menu
                    ></v-col>
                    <!-- <v-col cols="6" class="pt-0">
                      <v-radio-group
                        :disabled="!disableNotPtomoter"
                        v-model="invoice.cuentasContables.postedInvoice"
                        class="mt-0 pt-0"
                      >
                        <template v-slot:label>
                          <div class="primary--text">
                            Factura contabilizada:
                          </div>
                        </template>
                        <div class="radio">
                          <v-radio :value="true">
                            <template v-slot:label>
                              <div>Factura Cobrada</div>
                            </template>
                          </v-radio>
                          <v-radio :value="false">
                            <template v-slot:label>
                              <div>Factura NO Cobrada</div>
                            </template>
                          </v-radio>
                          <span class="disclaimer"
                            >Marcar cuando se realiza el cobro de la
                            misma.</span
                          >
                        </div>
                      </v-radio-group>
                    </v-col> -->
                  </v-row>
                  <v-row
                    v-if="
                      getUserData &&
                      getUserData.sigla === 'DAF' &&
                      invoice.validatingPerson.date
                    "
                  >
                    <v-col cols="6">
                      <v-btn
                        class="mb-5 white--text px-8 mt-1"
                        :disabled="!valid"
                        color="primary"
                        @click="submit(3)"
                      >
                        <v-icon left>mdi-content-save-outline</v-icon>
                        Guardar
                      </v-btn>
                    </v-col>
                  </v-row>

                  <div v-if="getFinalPersona() === 0">
                    <v-row
                      v-if="
                        (isPromotor &&
                          (invoice.validationState === 1 ||
                            invoice.validationState === 0)) ||
                        (isPromotor &&
                          invoice.managingPersonDetails.date &&
                          invoice.validatingPerson.date) ||
                        (isPromotor &&
                          isValidador === false &&
                          invoice.validationState === 2) ||
                        disableNotPtomoter
                      "
                    >
                      <v-col cols="6">
                        <v-checkbox
                          v-model="askForValidation"
                          id="uno"
                          label="Solicitar validación"
                          color="primary"
                          hide-details
                        ></v-checkbox>
                        <v-btn
                          class="mb-5 white--text px-8 mt-1"
                          :disabled="!valid"
                          color="primary"
                          @click="submit(0)"
                          ><v-icon left> mdi-content-save-outline</v-icon
                          >Guardar</v-btn
                        >
                      </v-col>
                    </v-row>
                  </div>
                  <div v-else-if="getFinalPersona() === 1">
                    <!-- If Promotor show save button + checkbox when gestor has validated -->
                    <v-row
                      v-if="isPromotor && invoice.managingPersonDetails.date"
                    >
                      <v-col cols="3">
                        <v-checkbox
                          v-model="askForValidation"
                          id="tres"
                          label="Solicitar validación"
                          color="primary"
                          hide-details
                        ></v-checkbox>
                        <v-btn
                          class="mb-5 white--text px-8 mt-1"
                          :disabled="!valid"
                          color="primary"
                          @click="submit(1)"
                          ><v-icon left> mdi-content-save-outline</v-icon
                          >Guardar</v-btn
                        >
                      </v-col>
                    </v-row>
                  </div>

                  <div v-else-if="getFinalPersona() === 2">
                    <div v-if="isPromotor && invoice.validatingPerson.date">
                      <!-- If Promotor show save button + checkbox when gestor has validated -->
                      <v-row>
                        <v-col cols="3">
                          <v-btn
                            class="mb-5 mt-6 white--text px-8 mt-1"
                            :disabled="!valid"
                            color="primary"
                            @click="submit(0)"
                            ><v-icon left> mdi-content-save-outline</v-icon
                            >Guardar</v-btn
                          >
                        </v-col>
                        <v-col cols="6">
                          <v-checkbox
                            v-model="askForValidation"
                            style="margin-top: 34px"
                            id="uno"
                            label="Solictar validación"
                            color="primary"
                            hide-details
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                      <!-- <small
                        >Revise todos los campos marcados en rojo antes de poder
                        guardar.</small
                      > -->
                    </div>
                    <!-- Valida Validador -->
                  </div>
                </v-form>
              </v-card-text>
              <v-divider class="mb-2"></v-divider>
              <!-- <v-card-actions class="pl-4" v-if="id">
                <v-btn
                  class="mb-5 white--text px-8"
                  :disabled="!valid"
                  color="primary"
                  @click="generatePDF"
                  ><v-icon left> mdi-file-replace-outline</v-icon>GENERAR
                  PDF</v-btn
                >
              </v-card-actions> -->
            </v-card>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import formatters from "@/utils/formatters.js";
import fieldValidation from "@/utils/fieldValidation.js";
import { mapGetters, mapActions } from "vuex";
import Snackbar from "@/components/Snackbar";
import services from "@/services/services";
import router from "@/router";
import CurrencyInput from "@/components/CurrencyInput.vue";
export default {
  name: "CreateEditIssued",
  props: ["id"],
  components: {
    Snackbar,
    CurrencyInput,
  },
  data() {
    return {
      askForValidationManager: false,
      whoClick: null,
      askForValidation: false,
      textError: null,
      isSnackbar: false,
      // isValidador: false,
      // invoiceManager: false,
      valid: true,
      amount: 0,
      amountToShow: {
        remainingProjectAmount: 0,
        // Base imponible
        taxBase: 0,
        totalVAT: 0,
        // Total Retención
        totalWithholding: 0,
        totalTopay: 0,
        // Debe
        hasToPay: 0,
        // Haber
        hasTohave: 0,
      },
      date: new Date().toISOString().substr(0, 10),
      ff: false,
      fv: false,
      fp: false,
      fc: false,
      radios: null,
      // centros: [
      //   { id: 1, name: "Centro 1" },
      //   { id: 2, name: "Centro 2" },
      // ],
      // contractingCompanies: [
      //   { id: 1, name: "Trambesòs" },
      //   { id: 2, name: "Tram de Barcelona" },
      // ],
      invoiceID: null,
      invoiceFile: null,
      emailFile: null,
      invoice: {
        type: "issued",
        company: "",
        invoiceNumber: "",
        PDFinvoiceFile: null,
        PDFinvoiceFileName: null,
        emailFile: null,
        emailFileName: null,
        invoiceDate: "",
        expirationDate: "",
        paymentDate: "",
        promoter: "",
        privado: "",
        // Fecha contabilización
        postingDate: "",
        client: "",
        totalTopay: 0,
        // Base imponible
        taxBase: 0,
        totalVAT: 0,
        // Total Retención
        totalWithholding: 0,
        // Cuentas contables
        cuentasContables: {
          // Debe
          hasToPay: "",
          // Haber
          hasTohave: "",
          // Factura contabilizada
          postedInvoice: false,
        },
        invoiceManager: {
          costCenter: "",
          managingPerson: "",
          validatingPerson: "",
        },
        managingPersonDetails: {
          validation: false,
          // null if no previous save
          date: null,
          description: "",
        },
        validatingPerson: {
          validation: false,
          // null if no previous save
          date: null,
          description: "",
        },
        validationState: 0,
      },
      dropDownField: [(v) => fieldValidation.dropDownValidation(v)],
      emptyField: [(v) => fieldValidation.emptyField(v)],
      // siglas: [
      //   { id: 1, sigla: "DG", name: "Direcció General" },
      //   { id: 2, sigla: "DAF", name: "Direcció d'Administració i Finances" },
      //   { id: 3, sigla: "DPE", name: "Direcció de Projectes Especials" },
      //   { id: 4, sigla: "DEX", name: "Direcció d'Explotació" },
      //   { id: 5, sigla: "DCO", name: "Direcció de Comunicació i RSE" },
      //   {
      //     id: 6,
      //     sigla: "DST",
      //     name: "Direcció de Sistemes Integrats de Gestió i TIC / CCO",
      //   },
      // ],
      rolesGV: [1, 2],
      rolesG: [3, 4],
    };
  },
  computed: {
    ...mapGetters([
      "getUserData",
      "getClientsAndSuppliers",
      "getUsers",
      "getInvoices",
      "getCenters",
      "getCompany",
      "getObjectById",
    ]),
    disableNotPtomoterContabilidad() {
      return (
        this.isPromotor ||
        (this.getUserData && this.getUserData.superAdmin) ||
        (this.getUserData && this.getUserData.sigla === "DAF")
      );
    },
    getClients() {
      return this.getClientsAndSuppliers.filter(
        (item) => item.type === "cliente"
      );
    },
    getUsersWithFullName() {
      return this.getUserData && this.getUsers
        ? this.getUsers
            .filter(
              (user) =>
                user.role.some((val) => this.rolesGV.includes(val)) &&
                user.status === true
            ) // Filter users based on the condition
            .sort((a, b) => {
              // Sort alphabetically by name
              const nameA = `${a.name} ${a.surname}`.toUpperCase(); // Ensure case-insensitive sorting
              const nameB = `${b.name} ${b.surname}`.toUpperCase();
              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }
              return 0;
            })
            .map((item) => {
              let fullName = `${item.name} ${item.surname}`;
              return { ...item, name: fullName };
            }) // Transform each item
        : [];
    },
    getAllUsers() {
      return this.getUsers
        .filter((item) => item.status === true) // Filter users with status === true
        .sort((a, b) => {
          // Sort alphabetically by name
          const nameA = `${a.name} ${a.surname}`.toUpperCase(); // Ensure case-insensitive sorting
          const nameB = `${b.name} ${b.surname}`.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        })
        .map((item) => {
          let fullName = `${item.name} ${item.surname}`;
          return { ...item, name: fullName };
        });
    },
    isValidador() {
      return (
        this.getUserData &&
        this.getUserData.role.some((val) => this.rolesGV.includes(val)) &&
        this.getUserData.id === this.invoice.invoiceManager.validatingPerson
      );
    },
    invoiceManager() {
      return (
        this.getUserData &&
        this.getUserData.role.some((val) => this.rolesG.includes(val)) &&
        this.getUserData.id === this.invoice.invoiceManager.managingPerson
      );
    },
    isPromotor() {
      return (
        this.getUserData &&
        this.getUserData.role.includes(3) &&
        this.getUserData.id === this.invoice.promoter
      );
    },
    centros() {
      return this.getCenters;
    },
    contractingCompanies() {
      return this.getCompany;
    },
    disableNotPtomoter() {
      return (
        this.isPromotor || (this.getUserData && this.getUserData.superAdmin)
      );
    },
    newDisable() {
      if (this.invoice.validationState >= 2) {
        if (this.getUserData && this.getUserData.superAdmin) return false;
        else return true;
      } else if (this.invoice.validationState < 2 && this.disableNotPtomoter)
        return false;
      else return true;
    },
    getDgUser() {
      if (
        this.getUserData &&
        (this.getUserData.sigla === "DG" || this.getUserData.sigla === "DG-1")
      )
        return true;
      else return false;
    },
  },
  watch: {
    getInvoices() {
      if (this.id && this.getInvoices) {
        this.invoice = this.getInvoices.find((item) => item.id === this.id);
        // const {
        //   taxBase,
        //   totalVAT,
        //   totalWithholding,
        //   // totalTopay,
        //   cuentasContables: { hasToPay, hasTohave },
        // } = this.invoice;
        // this.amountToShow = {
        //   remainingProjectAmount: formatters.amountFormatter.format(0),
        //   // Base imponible
        //   taxBase: formatters.amountFormatter.format(Number(taxBase)),
        //   totalVAT: formatters.amountFormatter.format(Number(totalVAT)),
        //   // Total Retención
        //   totalWithholding: formatters.amountFormatter.format(
        //     Number(totalWithholding)
        //   ),
        //   totalSupplied: formatters.amountFormatter.format(0),
        //   totalTopay: formatters.amountFormatter.format(
        //     parseFloat(this.invoice.taxBase) +
        //       parseFloat(this.invoice.totalVAT) -
        //       parseFloat(this.invoice.totalWithholding)
        //   ),
        //   // Debe
        //   hasToPay: formatters.amountFormatter.format(Number(hasToPay)),
        //   // Haber
        //   hasTohave: formatters.amountFormatter.format(hasTohave),
        // };
      } else {
        // this.amountToShow = {
        //   remainingProjectAmount: formatters.amountFormatter.format(0),
        //   // Base imponible
        //   taxBase: formatters.amountFormatter.format(0),
        //   totalVAT: formatters.amountFormatter.format(0),
        //   // Total Retención
        //   totalWithholding: formatters.amountFormatter.format(0),
        //   totalSupplied: formatters.amountFormatter.format(0),
        //   totalTopay: formatters.amountFormatter.format(0),
        //   // Debe
        //   hasToPay: formatters.amountFormatter.format(0),
        //   // Haber
        //   hasTohave: formatters.amountFormatter.format(0),
        // };
      }
    },
    invoice() {
      if (this.invoice.PDFinvoiceFile) {
        this.invoiceFile = new File(
          [this.invoice.PDFinvoiceFile],
          this.invoice.PDFinvoiceFileName,
          {
            type: "text/plain",
          }
        );
      }
      if (this.invoice.emailFile) {
        this.emailFile = new File(
          [this.invoice.emailFile],
          this.invoice.emailFileName,
          {
            type: "text/plain",
          }
        );
      }
      if (this.getUserData && this.invoice.promoter.length === 0) {
        this.invoice.promoter = this.getUserData.id;
      }
    },
    invoiceFile() {
      this.invoice.PDFinvoiceFileName = this.invoiceFile.name;
    },
    emailFile() {
      this.invoice.emailFileName = this.emailFile.name;
    },
    id() {
      if (this.id === undefined) {
        Object.assign(this.$data, this.$options.data.apply(this));
      }
    },
    privado() {
      this.invoice.privado = this.privado;
    },
  },
  methods: {
    ...mapActions(["setActionsLoader"]),
    sendInvoiceNotification(emailInfo) {
      if (
        emailInfo?.emailType === "internalEmailBodyInvoiceBill" &&
        emailInfo?.validationType === "validado" &&
        emailInfo?.validation === true
      ) {
        return;
      }
      services.sendEmail(emailInfo);
    },
    async submit(who) {
      this.whoClick = who;
      if (this.$refs.form.validate()) {
        if (
          this.askForValidation &&
          !this.invoice.validatingPerson.validation &&
          this.whoClick === 0
        ) {
          this.invoice.managingPersonDetails.validation = false;
        }
        this.setActionsLoader(true);
        this.invoice.totalTopay =
          parseFloat(this.invoice.taxBase) +
          parseFloat(this.invoice.totalVAT) -
          parseFloat(this.invoice.totalWithholding);
        if (this.id) {
          Promise.all(this.uploadFilse(this.id))
            .then((urlsData) => {
              urlsData.forEach((url) => {
                if (url.includes("invoiceFile.")) {
                  this.invoice.PDFinvoiceFile = url;
                } else if (url.includes("emailFile.")) {
                  this.invoice.emailFile = url;
                }
              });
              this.update();
            })
            .catch((error) => {
              this.setActionsLoader(false);
              console.log(`Some failed: `, error.message);
            });
        } else {
          let isSaved = await this.save();
          if (isSaved) {
            Promise.all(this.uploadFilse(this.invoiceID))
              .then((urlsData) => {
                urlsData.forEach((url) => {
                  if (url.includes("invoiceFile.")) {
                    this.invoice.PDFinvoiceFile = url;
                  } else if (url.includes("emailFile.")) {
                    this.invoice.emailFile = url;
                  }
                });
                this.update();
              })
              .catch((error) => {
                this.setActionsLoader(false);
                console.log(`Some failed: `, error.message);
              });
          }
        }
      }
    },
    formatWithCurrency(field) {
      if (
        field === "taxBase" ||
        field === "totalVAT" ||
        field === "totalWithholding"
      ) {
        this.invoice.totalTopay =
          parseFloat(this.invoice.taxBase) +
          parseFloat(this.invoice.totalVAT) -
          parseFloat(this.invoice.totalWithholding);
      }
    },
    generatePDF() {
      // need to be clear what to be on the PDF
      console.log("Generating PDF ....");
    },
    async save() {
      let that = this;
      return new Promise((resolve, reject) => {
        services
          .saveData("invoices", this.invoice)
          .then((data) => {
            this.setActionsLoader(false);
            that.invoiceID = data.id;
            this.textError = null;
            this.isSnackbar = true;
            resolve(true);
          })
          .catch((e) => {
            console.error(e);
            this.setActionsLoader(false);
            this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
            this.isSnackbar = true;
            reject(false);
          });
      });
    },
    async update() {
      this.sendEmailManagerOrValidator();
      return new Promise((resolve, reject) => {
        if (this.askForValidation && this.isPromotor && this.whoClick === 0) {
          if (
            this.invoice.invoiceManager.managingPerson ===
            this.invoice.invoiceManager.validatingPerson
          ) {
            this.invoice.validationState = 2;
          } else {
            this.invoice.validationState = 1;
          }
          this.invoice.managingPersonDetails.date = null;
          this.invoice.validatingPerson.date = null;
        }
        services
          .updateData("invoices", {
            id: this.id || this.invoiceID,
            payload: this.invoice,
          })
          .then(() => {
            this.setActionsLoader(false);
            this.textError = null;
            this.isSnackbar = true;
            resolve(true);
            const managingPerson = this.getUserById(
              this.invoice.invoiceManager.managingPerson
            );
            if (this.isPromotor && this.whoClick === 0) {
              // alert(
              //   `Enviar email a Gestor: ${managingPerson.email} para validar el factura!`
              // );
              let link = this.id
                ? window.location.href
                : window.location.href +
                  `/${this.invoice.id || this.invoiceID}`;
              let emailInfo = {
                emailType: "internalEmailBodyInvoiceBill",
                to: managingPerson.email,
                from: this.getUserData.email,
                fileName: "",
                userWhoSend: `${this.getUserData.name} ${this.getUserData.surname}`,
                link: link,
                type: this.invoice.type,
                validation: false,
                reasonDisagreement: "",
                validationType: "validar",
                userWhoRecive: `${managingPerson.name} ${managingPerson.surname}`,
                totalTopay: formatters.amountFormatter.format(
                  this.invoice.totalTopay
                ),
                contractingCompany: this.invoice.company,
                providerCompany: this.getObjectById(
                  "clientsAndSuppliers",
                  this.invoice.client
                ).businessName,
                invoiceBillNumber: this.invoice.invoiceNumber,
              };
              if (this.askForValidation) {
                this.sendInvoiceNotification(emailInfo);
              }
            }
            setTimeout(() => {
              //router.push("/invoices/2");
              router.go(-1);
            }, 300);
          })
          .catch((e) => {
            console.error(e);
            this.setActionsLoader(false);
            this.textError = "Algo salió mal. Por favor, vuelva a intentarlo";
            this.isSnackbar = true;
            reject(false);
          });
      });
    },
    uploadFilse(invoiceId) {
      let filesPromises = [];
      if (this.invoiceFile && this.invoiceFile.type !== "text/plain") {
        filesPromises.push(
          services.files.uploadFile(
            "invoices",
            "invoiceFile." + invoiceId + "-" + this.invoiceFile.name,
            this.invoiceFile
          )
        );
      }
      if (this.emailFile && this.emailFile.type !== "text/plain") {
        filesPromises.push(
          services.files.uploadFile(
            "invoices",
            "emailFile." + invoiceId + "-" + this.emailFile.name,
            this.emailFile
          )
        );
      }
      return filesPromises;
    },
    getUserById(id) {
      return this.getUsers.find((user) => user.id === id);
    },
    getFinalPersona() {
      // should disable
      //services.disableAll(this.isPromotor, this.id);
      if (this.isPromotor && this.invoiceManager && !this.isValidador) {
        if (this.id === undefined && this.whoClick === null) {
          this.invoice.validationState = 1;
        }
        // Gestor button show A A B
        return 1;
      } else if (!this.isPromotor && this.invoiceManager && this.isValidador) {
        if (this.id === undefined && this.whoClick === null) {
          this.invoice.validationState = 2;
        }
        // Validator button show A B B will not see promotr button after validation
        return 2;
      } else if (this.isPromotor && this.invoiceManager && this.isValidador) {
        if (this.id === undefined && this.whoClick === null) {
          this.invoice.validationState = 2;
        }
        // Validator button show A A A will see promotr button after validation
        return 2;
      } else {
        if (this.id === undefined && this.whoClick === null) {
          this.invoice.validationState = 0;
        }
        // Normal flow A B C
        return 0;
      }
    },
    sendEmailManagerOrValidator() {
      let emailInfo;
      let link = this.id
        ? window.location.href
        : window.location.href + `/${this.invoice.id || this.invoiceID}`;
      const validator = this.getUserById(
        this.invoice.invoiceManager.validatingPerson
      );
      const promoter = this.getUserById(this.invoice.promoter);
      if (
        this.invoiceManager &&
        this.whoClick === 1 &&
        (this.askForValidationManager || this.askForValidation)
      ) {
        this.invoice.managingPersonDetails.date = new Date().toLocaleString();
        // .split("/")
        // .reverse()
        // .join("-");
        if (!this.invoice.managingPersonDetails.validation) {
          //alert(`Enviar email a Promoter: ${promoter.email} no conforme!`);
          emailInfo = {
            emailType: "internalEmailBodyInvoiceBill",
            to: promoter.email,
            from: this.getUserData.email,
            fileName: "",
            userWhoSend: `${this.getUserData.name} ${this.getUserData.surname}`,
            link: link,
            type: this.invoice.type,
            validation: false,
            reasonDisagreement: this.invoice.managingPersonDetails.description,
            validationType: "validado",
            userWhoRecive: `${promoter.name} ${promoter.surname}`,
            totalTopay: formatters.amountFormatter.format(
              this.invoice.totalTopay
            ),
            contractingCompany: this.invoice.company,
            providerCompany: this.getObjectById(
              "clientsAndSuppliers",
              this.invoice.client
            ).businessName,
            invoiceBillNumber: this.invoice.invoiceNumber,
          };
          this.invoice.validationState = 0;
        } else {
          // alert(
          //   `Enviar email a Validador: ${validator.email} para validar el factura!`
          // );
          emailInfo = {
            emailType: "internalEmailBodyInvoiceBill",
            to: validator.email,
            from: this.getUserData.email,
            fileName: "",
            type: this.invoice.type,
            userWhoSend: `${this.getUserData.name} ${this.getUserData.surname}`,
            link: link,
            validation: false,
            reasonDisagreement: "",
            validationType: "validar",
            userWhoRecive: `${validator.name} ${validator.surname}`,
            totalTopay: formatters.amountFormatter.format(
              this.invoice.totalTopay
            ),
            contractingCompany: this.invoice.company,
            providerCompany: this.getObjectById(
              "clientsAndSuppliers",
              this.invoice.client
            ).businessName,
            invoiceBillNumber: this.invoice.invoiceNumber,
          };
          this.invoice.validatingPerson.date = null;
          this.invoice.validationState = 2;
        }
        this.sendInvoiceNotification(emailInfo);
      } else if (this.isValidador && this.whoClick === 2) {
        if (this.invoiceManager && this.isValidador) {
          this.invoice.managingPersonDetails.date = new Date().toLocaleString();
          if (this.invoice.validatingPerson.validation) {
            this.invoice.managingPersonDetails.validation = true;
          }
        }
        this.invoice.validatingPerson.date = new Date().toLocaleString();
        if (!this.invoice.validatingPerson.validation) {
          const managingPerson = this.getUserById(
            this.invoice.invoiceManager.managingPerson
          );
          // alert(
          //   `Enviar email a Gestor: ${managingPerson.email} no conforme!`
          // );
          let to, userWhoRecive;
          if (this.invoiceManager && this.isValidador) {
            to = promoter.email;
            userWhoRecive = `${promoter.name} ${promoter.surname}`;
          } else {
            to = managingPerson.email;
            userWhoRecive = `${managingPerson.name} ${managingPerson.surname}`;
          }
          emailInfo = {
            emailType: "internalEmailBodyInvoiceBill",
            to: to,
            cc:
              (promoter.id === managingPerson.id) === false
                ? to === promoter.email
                  ? null
                  : promoter.email
                : null,
            from: this.getUserData.email,
            fileName: "",
            userWhoSend: `${this.getUserData.name} ${this.getUserData.surname}`,
            link: link,
            type: this.invoice.type,
            validation: false,
            reasonDisagreement: this.invoice.validatingPerson.description,
            validationType: "validado",
            userWhoRecive: userWhoRecive,
            totalTopay: formatters.amountFormatter.format(
              this.invoice.totalTopay
            ),
            contractingCompany: this.invoice.company,
            providerCompany: this.getObjectById(
              "clientsAndSuppliers",
              this.invoice.client
            ).businessName,
            invoiceBillNumber: this.invoice.invoiceNumber,
          };
          if (promoter.id === managingPerson.id) {
            this.invoice.validationState = 1;
          } else {
            this.invoice.validationState = 0;
          }
          if ((this.invoiceManager && this.isValidador) === false) {
            this.invoice.managingPersonDetails.date = null;
          }
          this.sendInvoiceNotification(emailInfo);
        } else {
          const managingPerson = this.getUserById(
            this.invoice.invoiceManager.managingPerson
          );
          emailInfo = {
            emailType: "internalEmailBodyInvoiceBill",
            to: promoter.email,
            cc: promoter.id !== managingPerson.id ? managingPerson.email : null,
            from: this.getUserData.email,
            fileName: "",
            userWhoSend: `${this.getUserData.name} ${this.getUserData.surname}`,
            link: link,
            type: this.invoice.type,
            validation: true,
            reasonDisagreement: "",
            validationType: "validado",
            userWhoRecive: `${promoter.name} ${promoter.surname}`,
            totalTopay: formatters.amountFormatter.format(
              this.invoice.totalTopay
            ),
            contractingCompany: this.invoice.company,
            providerCompany: this.getObjectById(
              "clientsAndSuppliers",
              this.invoice.client
            ).businessName,
            invoiceBillNumber: this.invoice.invoiceNumber,
          };
          this.invoice.validationState = 1;
          this.sendInvoiceNotification(emailInfo);
        }
      }
    },
    downloadFile(dataUrl, filename) {
      services.downloadFile(dataUrl, filename);
    },
  },
  created() {
    if (this.getUserData && this.invoice.promoter.length === 0) {
      this.invoice.promoter = this.getUserData.id;
    }
    if (this.id && this.getInvoices) {
      this.invoice = this.getInvoices.find((item) => item.id === this.id);
      // const {
      //   taxBase,
      //   totalVAT,
      //   totalWithholding,
      //   // totalTopay,
      //   cuentasContables: { hasToPay, hasTohave },
      // } = this.invoice;
      // this.amountToShow = {
      //   remainingProjectAmount: formatters.amountFormatter.format(0),
      //   // Base imponible
      //   taxBase: formatters.amountFormatter.format(Number(taxBase)),
      //   totalVAT: formatters.amountFormatter.format(Number(totalVAT)),
      //   // Total Retención
      //   totalWithholding: formatters.amountFormatter.format(
      //     Number(totalWithholding)
      //   ),
      //   totalSupplied: formatters.amountFormatter.format(0),
      //   totalTopay: formatters.amountFormatter.format(
      //     parseFloat(this.invoice.taxBase) +
      //       parseFloat(this.invoice.totalVAT) -
      //       parseFloat(this.invoice.totalWithholding)
      //   ),
      //   // Debe
      //   hasToPay: formatters.amountFormatter.format(Number(hasToPay)),
      //   // Haber
      //   hasTohave: formatters.amountFormatter.format(hasTohave),
      // };
    }
    // else {
    //   this.amountToShow = {
    //     remainingProjectAmount: formatters.amountFormatter.format(0),
    //     // Base imponible
    //     taxBase: formatters.amountFormatter.format(0),
    //     totalVAT: formatters.amountFormatter.format(0),
    //     // Total Retención
    //     totalWithholding: formatters.amountFormatter.format(0),
    //     totalSupplied: formatters.amountFormatter.format(0),
    //     totalTopay: formatters.amountFormatter.format(0),
    //     // Debe
    //     hasToPay: formatters.amountFormatter.format(0),
    //     // Haber
    //     hasTohave: formatters.amountFormatter.format(0),
    //   };
    // }
  },
};
</script>

<style scoped>
.v-icon.v-icon:after {
  background-color: white;
}
small {
  display: block;
  margin-top: -20px;
}
.breadcrumbs__title {
  padding: 8px 0;
  border-bottom: 3px solid #008076;
  margin: 0;
  display: inline-block;
}

.theme--light.v-image {
  align-self: center;
  border-radius: 10%;
}

.v-application--is-ltr .v-card__actions > .v-btn.v-btn + .v-btn {
  margin: 0;
}

.col-6 {
  padding: 0 12px;
}

.disclaimer {
  opacity: 0.6;
  font-size: 12px;
}

.custom__title {
  font-size: 16px !important;
}
/* Here to remove background */
.v-icon.v-icon::after {
  background-color: white;
}
</style>
